import update from 'immutability-helper'
import React from 'react'
import Text from 'react-text'
import LinesEllipsis from 'react-lines-ellipsis'
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {Consumer} from '../../../../context'
import Label from '../../../label'
import confirmDialog from '../../../confirm-dialog'
import AddLinkResource from '../../../add-link-resource'
import Menu from './menu'

import './index.styl'

function ResourceLink (props) {
  const {title, href, deleteResource} = props
  return (
    <div className="resource link">
      <div className="content">
        <div className="id">{title}</div>
        <a className="link" href={href} targe="_blank" title={href}>
          <LinesEllipsis
            text={href}
            maxLine={1}
            ellipsis="..."
            trimRight
            basedOn='letters'
          />
        </a>
      </div>
      <div className="actions">
        <div className="delete" onClick={deleteResource}>
          <FontAwesomeIcon icon={faTrashAlt} />
        </div>
      </div>
    </div>
  )
}

const resourceMap = {link: ResourceLink}

export default function AddResource () {

  return (<Consumer>{ context => {
    const {newPlan, languageId, link} = context
    const {content = {}} = newPlan
    const {resources = []} = content

    const deleteResource = (index, title) => {
      return () => {
        confirmDialog({
          className: 'delete-resource',
          translate: context.translate,
          children: (
            <div className="message">
              <div className="question">
                {context.translate('confirm_delete_item')}
              </div>
              <div className="title">
                {title}
              </div>
            </div>
          ),
          onConfirm: () => {
            const resources = update(newPlan.content.resources, {$splice: [[index,1]]})
            context.setState({newPlan: {...newPlan, content: {...content, resources}}})
          }
        })
      }
    }

    const items = resources
      .filter(({type}) => resourceMap[type])
      .map((resource, index) => {
        const Resource = resourceMap[resource.type]
        return (
          <Resource
            key={index}
            index={index}
            className="resource"
            deleteResource={deleteResource(index, resource.title)}
            context={context}
            {...resource}
          />
        )
      })

    return (
      <div className="resources">
        { context.section == 'add-link-resource' && (<AddLinkResource />)}
        <div className="head">
          <label><Text id="digital-resources" /></label>
          <Menu />
        </div>
        { items.length > 0 && (
          <div className="content">
            {items}
          </div>
        )}
      </div>
    )}}</Consumer>)
}
